import React from "react";

import { Grid } from "@mui/material";
import { GaelicRun } from "./Items/GaelicRun";
import { Fuaim } from "./Items/Fuaim";
import { Facle } from "./Items/Facle";
import { Cuimhne } from "./Items/Cuimhne";
import { Cairtean } from "./Items/Cairtean";
import { About } from "./Items/About";

const App = () => {
  return (
    <div className="container">
      <Grid container spacing={5}>
        <Grid
          item
          style={{
            width: "250px",
          }}
          xs={12}
          sm={6}
          md={4}
        >
          <a href="http://gaelicrun.gordonmaloney.info" target="_blank">
            <GaelicRun />
          </a>
        </Grid>

        <Grid
          item
          style={{
            width: "250px",
          }}
          xs={12}
          sm={6}
          md={4}
        >
          <a href="http://fuaim.gordonmaloney.info" target="_blank">
            <Fuaim />
          </a>
        </Grid>

        <Grid
          item
          style={{
            width: "250px",
          }}
          xs={12}
          sm={6}
          md={4}
        >
          <a href="http://facle.gordonmaloney.info" target="_blank">
            <Facle />
          </a>
        </Grid>

        <Grid
          item
          style={{
            width: "250px",
          }}
          xs={12}
          sm={6}
          md={4}
        >
          <a href="http://cuimhne.gordonmaloney.info" target="_blank">
            <Cuimhne />
          </a>
        </Grid>

        <Grid
          item
          style={{
            width: "250px",
          }}
          xs={12}
          sm={6}
          md={4}
        >
          <a href="http://cairtean.gordonmaloney.info" target="_blank">
            <Cairtean />
          </a>
        </Grid>

        <Grid
          item
          style={{
            width: "250px",
          }}
          xs={12}
          sm={6}
          md={4}
        >
          <a href="https://ko-fi.com/gordonmaloney" target="_blank">
            <About />
          </a>
        </Grid>
      </Grid>


    </div>
  );
};

export default App;
